import React, { Component } from 'react';

class Home extends Component {
    render() {
        return (
            <div className="profile">
                <pre>{JSON.stringify(this.props.userInfo, null, '\t')}</pre>
            </div>
        );
    }
}

export default Home;



// WEBPACK FOOTER //
// ./src/components/userInfo/index.js